import { render } from "./RealTime.vue?vue&type=template&id=fbcb91d0&ts=true"
import script from "./RealTime.vue?vue&type=script&lang=ts"
export * from "./RealTime.vue?vue&type=script&lang=ts"

import "./RealTime.vue?vue&type=style&index=0&id=fbcb91d0&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__